import { useMutation } from 'react-query';
import { updateDemandChangeDates } from 'src/services/api/demands';

function useUpdateDemandChangeDates() {
  return useMutation(({ demand, data, doctorId }) =>
    updateDemandChangeDates(demand, data, { doctorId }),
  );
}

export default useUpdateDemandChangeDates;
